import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "#121212",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m10.001 2.798 2.127 4.308a.5.5 0 0 0 .376.274l4.756.695-3.44 3.352a.5.5 0 0 0-.145.443l.812 4.734-4.253-2.236a.5.5 0 0 0-.465 0l-4.254 2.236.812-4.734a.5.5 0 0 0-.143-.443L2.742 8.075 7.5 7.38a.5.5 0 0 0 .376-.274L10 2.798Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "star"}) } }